<template>
  <div class="box">
    <div class="main-content">
      <!-- 链接类型部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">链接类型:</div>
          </div>
          <div class="main-content-right">
            <div v-show="editableOrNot" class="selectType-box flex spaceBetween">
              <div @click="selectType = 'web'" :class="this.selectType == 'web' ? 'selectType' : 'unSelectType'">资源链接
              </div>
              <div @click="selectType = 'h5'" :class="this.selectType == 'h5' ? 'selectType' : 'unSelectType'">特殊互动
              </div>
            </div>
            <div v-show="!editableOrNot" class="selectType-box flex spaceBetween">
              <div :class="this.selectType == 'web' ? 'superSelectType' : 'superUnSelectType'">资源链接</div>
              <div :class="this.selectType == 'h5' ? 'superSelectType' : 'superUnSelectType'">特殊互动</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 链接类型部分结束 -->
      <!-- 链接名称部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">链接名称:</div>
          </div>
          <div class="main-content-right">
            <div class="publicInput-box">
              <input v-show="editableOrNot" v-model="interlinkageName" class="publicInput" type="text"
                placeholder="请输入链接名称" />
              <input v-show="!editableOrNot" disabled v-model="interlinkageName" class="publicInput" type="text"
                placeholder="请输入链接名称" />
            </div>
          </div>
        </div>
      </div>
      <!-- 链接名称部分结束 -->
      <!-- 链接分值部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">链接分值:</div>
          </div>
          <div class="flex main-content-right">
            <input v-show="editableOrNot" class="linkageNameScore-range" @input="linkageNameScoreInput"
              :value="linkageNameScore || 0" type="range" min="0" max="100" />
            <input v-show="!editableOrNot" disabled class="linkageNameScore-range" @input="linkageNameScoreInput"
              :value="linkageNameScore || 0" type="range" min="0" max="100" />
            <input v-show="editableOrNot" class="linkageNameScore-text" v-model="linkageNameScore"
              oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>100)value=100;if(value<0)value=0" />
            <input v-show="!editableOrNot" disabled class="linkageNameScore-text" v-model="linkageNameScore" />
          </div>
        </div>
      </div>
      <!-- 链接分值部分结束 -->
      <!-- 所属课次部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">所属课次:</div>
          </div>
          <div class="main-content-right">
            <van-popover close-on-click-outside placement="bottom-start" v-model="showPopover">
              <div class="selectClass-box">
                <van-checkbox-group style="margin-top: 20px" v-for="(item, index) in classList" :key="index"
                  v-model="checked">
                  <van-checkbox @click="changeCheckbox(item.name, item.id)" shape="square" :name="item.name">课次 {{ index
              + 1 }} {{ item.name }}</van-checkbox>
                </van-checkbox-group>
              </div>
              <template #reference>
                <div v-show="editableOrNot" @click="showPopover = true" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                  <img @click="showPopover = true" style="margin-right: 17px"
                    src="../../assets/courseInformation/add.png" />
                </div>
                <div v-show="!editableOrNot" class="publicInput-box flex align spaceBetween">
                  <input v-model="checked" disabled class="publicInput" type="text" placeholder="请选择所属课次" />
                  <img style="margin-right: 17px" src="../../assets/courseInformation/add.png" />
                </div>
              </template>
            </van-popover>
          </div>
        </div>
      </div>
      <!-- 所属课次部分结束 -->
      <!-- 链接用途部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">链接用途:</div>
          </div>
          <div class="main-content-right">
            <div v-show="editableOrNot" class="usage-box flex spaceBetween">
              <div @click="linkPurpose = 'front'" class="flex align pointer">
                <div :class="this.linkPurpose == 'front' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.linkPurpose == 'front' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课前</div>
              </div>
              <div @click="linkPurpose = 'middle'" class="flex align pointer">
                <div :class="this.linkPurpose == 'middle' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.linkPurpose == 'middle' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课中</div>
              </div>
              <div @click="linkPurpose = 'back'" class="flex align pointer">
                <div :class="this.linkPurpose == 'back' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.linkPurpose == 'back' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课后</div>
              </div>
            </div>
            <div v-show="!editableOrNot" class="usage-box flex spaceBetween">
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.linkPurpose == 'front' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.linkPurpose == 'front' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课前</div>
              </div>
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.linkPurpose == 'middle' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.linkPurpose == 'middle' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课中</div>
              </div>
              <div class="flex align pointer" style="cursor: not-allowed">
                <div :class="this.linkPurpose == 'back' ? 'selectLinkCircle' : 'unSelectLinkCircle'"></div>
                <div :class="this.linkPurpose == 'back' ? 'selectLinkTxt' : 'unSelectLinkTxt'">课后</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 链接用途部分结束 -->
      <!-- 链接地址部分开始 -->
      <div class="publicMarginTop">
        <div class="flex align justify">
          <div class="flex">
            <div class="requiredIcon">*</div>
            <div class="informationTxt">链接地址:</div>
          </div>
          <div class="main-content-right">
            <div class="publicInput-box">
              <input v-show="editableOrNot" v-model="linkAddress" class="publicInput" type="text"
                placeholder="请输入链接地址" />
              <input v-show="!editableOrNot" disabled v-model="linkAddress" class="publicInput" type="text"
                placeholder="请输入链接地址" />
            </div>
          </div>
        </div>
      </div>
      <!-- 链接地址部分结束 -->
      <!-- 按钮 -->
      <div v-show="editableOrNot" class="btn-box flex spaceBetween">
        <div @click="btnUpload" class="pushButton pointer">上传</div>
        <div @click="btnCancel" class="pushButton pointer">取消</div>
      </div>
      <div v-show="!editableOrNot" class="btn-box flex justify">
        <div @click="btnCancel" class="pushButton pointer">返回</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { resourceAddition, resourceModification, resourceAssociationAdd, resourceAssociationDel } from "@/api";
export default {
  data() {
    return {
      editableOrNot: true, // 是否可编辑
      identity: "", // 登录身份
      checked: [],
      showPopover: false,
      selectType: "web", // 当前选中的链接类型
      interlinkageName: "", // 输入的链接名称
      linkageNameScore: 0, // 链接分值
      linkPurpose: "", // 当前选中的链接用途
      linkAddress: "", // 输入的链接地址
      classList: [], // 所属课次
      classesList: [], // 所属课次列表
    };
  },
  created() {
    this.editableOrNot = this.$store.state.editableOrNot; // 获取是否可编辑状态
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    this.classList = this.$store.state.classListRecord;
    if (this.$route.params.record) {
      let xiu = this.$route.params.record;
      console.log(xiu);
      this.interlinkageName = xiu.name; // 链接名称
      this.linkAddress = xiu.content[0];
      this.linkageNameScore = xiu.score.replace("分", ""); // 资源分值
      for (let i = 0; i < xiu.lesson_items.length; i++) {
        this.checked.push(xiu.lesson_items[i].name);
      }
      if (xiu.usage == "课前") {
        this.linkPurpose = "front";
      } else if (xiu.usage == "课中") {
        this.linkPurpose = "middle";
      } else if (xiu.usage == "课后") {
        this.linkPurpose = "back";
      }
      if (xiu.types == "资源链接") {
        this.selectType = "web";
      } else if (xiu.types == "特殊互动") {
        this.selectType = "h5";
      }
    }
    if (this.$route.params.whetherModified) {
      if (this.$route.params.whetherModified == "no") {
        this.editableOrNot = false;
      }
    }
  },
  methods: {
    // 更改链接所属课次
    changeCheckbox(classIdx, idx) {
      if (this.classesList.indexOf(idx) > -1) {
        this.classesList.splice(this.classesList.indexOf(idx), 1);
      } else {
        this.classesList.push(idx);
      }
      if (this.$route.params.record) {
        // console.log("当前选中的课次", classIdx);
        // console.log("课次数组", this.checked);
        // console.log("当前选中的课次下标", this.checked.indexOf(classIdx));
        if (this.checked.indexOf(classIdx) === -1) {
          // 删除习题课次关联
          let data = { link_resource_id: this.$route.params.record.link_resource_id, lesson_item_id: idx, types: "assets" };
          resourceAssociationDel(data).then((res) => { });
        } else {
          // 添加习题课次关联
          let data = { resource_id: this.$route.params.record.id, lesson_item_id: idx, lesson_id: this.$store.state.courseDetails.id, types: "assets" };
          resourceAssociationAdd(data).then((res) => { });
        }
      }
    },
    // 链接分值滑块
    linkageNameScoreInput() {
      let dom = document.getElementsByClassName("linkageNameScore-range")[0];
      let value = dom.value;
      if (value) this.linkageNameScore = value;
    },
    // 上传按钮
    btnUpload() {
      if (this.selectType != "" && this.checked.length != 0 && this.linkPurpose != "" && this.linkAddress != "" && this.selectType != "" && this.$store.state.courseDetails.id != "") {
        if (!this.$route.params.record) {
          let total1 = "";
          for (let i = 0; i < this.classesList.length; i++) {
            total1 += this.classesList[i] + ",";
          }
          let data = {
            name: this.interlinkageName,
            score: this.linkageNameScore,
            lesson_item_ids: total1,
            usage: this.linkPurpose,
            content: this.linkAddress,
            types: this.selectType,
            lesson_id: this.$store.state.courseDetails.id,
          };
          // 资源添加
          resourceAddition(data).then((res) => {
            if (res.data.code == 0) {
              this.$router.push("/resourceManagement");
              Toast("上传成功！");
            }
          });
        } else {
          let data = {
            name: this.interlinkageName,
            score: this.linkageNameScore,
            percent: this.linkageNameScore,
            usage: this.linkPurpose,
            content: this.linkAddress,
            types: this.selectType,
            id: this.$route.params.record.id,
          };
          resourceModification(data).then((res) => {
            if (res.data.code == 0) {
              this.$router.push("/resourceManagement");
              Toast("修改成功！");
            }
          });
        }
      } else {
        if (this.selectType == "") {
          Toast("请选择链接类型！");
        } else if (this.interlinkageName == "") {
          Toast("请输入链接名称!");
        } else if (this.checked.length == 0) {
          Toast("请选择所属课次！");
        } else if (this.linkPurpose == "") {
          Toast("请选择资源用途！");
        } else if (this.linkAddress == "") {
          Toast("请输入链接地址！");
        }
      }
    },
    // 取消按钮
    btnCancel() {
      this.$router.push("/resourceManagement");
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

.box {
  width: 100%;
  height: 100%;
  display: flex;
}

.main-content {
  width: 1740px;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.requiredIcon {
  width: 10px;
  height: 10px;
  color: #ff0000;
}

.requiredIcon1 {
  opacity: 0;
}

.informationTxt {
  font-size: 22px;

  font-weight: 400;
  color: #555555;
}

.selectType {
  width: 120px;
  height: 40px;
  background: #349afe;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.superSelectType {
  width: 120px;
  height: 40px;
  background: #349afe;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  opacity: 0.5;
  cursor: not-allowed;
}

.unSelectType {
  width: 120px;
  height: 40px;
  background: #bbbbbb;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
}

.superUnSelectType {
  width: 120px;
  height: 40px;
  background: #bbbbbb;
  border-radius: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  cursor: not-allowed;
}

.main-content-right {
  width: 761px;
  margin-left: 35px;
}

// 公共输入框样式
.publicInput-box {
  width: 761px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
}

.publicInput {
  font-size: 20px;

  font-weight: 400;
  color: #555555;
  margin-left: 17px;
  width: 600px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

// 资源分值滑块
.linkageNameScore-range {
  display: flex;
  align-items: center;
}

input[type="range"] {
  appearance: none;
  width: 368px;
  border-radius: 10px;
  /*这个属性设置使填充进度条时的图形为圆角*/
}

// 自定义进度条
input[type="range"]::-webkit-slider-runnable-track {
  width: 368px;
  height: 6px;
  background: #dddddd;
  border-radius: 3px;
  cursor: pointer;
}

// 自定义滑块
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  /*清除系统默认样式*/
  width: 20px;
  height: 20px;
  background: #349afe;
  border-radius: 50%;
  margin-top: -7px; // 使滑块超出轨道部分的偏移量相等
  cursor: e-resize;
}

.linkageNameScore-text {
  margin-left: 24px;
  width: 64px;
  height: 40px;
  border: 1px solid #757575;
  border-radius: 10px;
  font-size: 22px;

  font-weight: 400;
  color: #349afe;
  background-color: transparent;
  outline: none;
  text-align: center;
}

.selectLinkCircle {
  width: 12px;
  height: 12px;
  background: #349afe;
  border-radius: 50%;
}

.unSelectLinkCircle {
  width: 8px;
  height: 8px;
  border: 2px solid #b8b8b8;
  border-radius: 50%;
}

.selectLinkTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #349afe;
}

.unSelectLinkTxt {
  margin-left: 6px;
  font-size: 20px;

  font-weight: 400;
  color: #b9b9b9;
}

.selectClass-box {
  width: 761px;
  max-height: 300px;
  padding: 0px 20px 20px 20px;
  box-sizing: border-box;
  overflow: scroll;
}

.pushButton {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}

.selectType-box {
  width: 279px;
}

.usage-box {
  width: 262px;
}

.btn-box {
  position: absolute;
  width: 410px;
  bottom: 80px;
}

.publicMarginTop {
  margin-top: 30px;
}
</style>
